import { Images } from "@assets/images";
import { CustomSelect } from "../select/custom-select";
import ChevronDownArrow from "../select/chevron-down";

interface TitleDescriptionProps {
  title: string;

  isSelectButtonShow?: boolean;

  onInputChange?: (value: string) => void;
}

function TitleDescription({
  title,
  isSelectButtonShow = false,
  onInputChange = () => {},
}: TitleDescriptionProps) {
  return (
    <div className="flex justify-between items-center">
      <div className="black-60">{title}</div>
      <div>
        <div className="flex items-center gap-3">
          <div className="w-full flex relative">
            <input
              className="w-full outline-none pl-10 px-4 h-9 leading-9 rounded black-60 border border-solid border-[#CFD3D4] text-xs"
              placeholder="Tìm kiếm"
              onChange={(event) => onInputChange(event.target.value)}
            />
            <img
              className="absolute w-4 h-4 left-2 top-[10px]"
              src={Images.SearchIcon.default}
              alt=""
            />
          </div>
          {isSelectButtonShow && (
            <CustomSelect
              className="!border-[#53545C] pr-2 w-28"
              options={[{ label: "Bulk Action", value: "all" }]}
              optionContainerClassName="top-[34px] w-28"
              optionClassName="!min-h-[35px] text-[11px] text-black whitespace-nowrap px-2"
              labelSelectedClassName="black-50 text-[11px]"
              arrow={<ChevronDownArrow />}
              defaultValue="all"
              hasBgColorHover
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default TitleDescription;
